import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { siteData } from '../data/mockData';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { useTranslation } from '../data/translations';

const ProjectCard = ({ project, index }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setIsVisible(true); }, { threshold: 0.2 });
    if (cardRef.current) obs.observe(cardRef.current);
    return () => obs.disconnect();
  }, []);

  const slug = project.link.replace('/projecten/', '');
  return (
    <div ref={cardRef} className="group block relative overflow-hidden cursor-pointer" onClick={() => { navigate(`/projecten/${slug}`); window.scrollTo({top:0}); }} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}
      style={{ opacity: isVisible ? 1 : 0, transform: isVisible ? 'translateY(0)' : 'translateY(60px)', transition: `all 0.8s cubic-bezier(0.16, 1, 0.3, 1) ${index * 150}ms` }}>
      <div className="relative aspect-[4/3] overflow-hidden rounded-sm">
        <img src={project.image} alt={project.title} className="w-full h-full object-cover transition-transform duration-700" style={{ transform: isHovered ? 'scale(1.08)' : 'scale(1)' }} />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent transition-opacity duration-500" style={{ opacity: isHovered ? 1 : 0.3 }} />
        <div className="absolute bottom-4 right-4 flex items-center gap-2 text-white text-sm font-medium transition-all duration-500" style={{ opacity: isHovered ? 1 : 0, transform: isHovered ? 'translateX(0)' : 'translateX(20px)' }}>
          <ArrowRight size={16} />
        </div>
      </div>
      <h3 className="mt-4 text-lg md:text-xl font-bold text-white tracking-wider uppercase">{project.title}</h3>
    </div>
  );
};

const ProjectsSection = () => {
  const { lang } = useLanguage();
  const { t, get } = useTranslation(lang);
  const [headingVisible, setHeadingVisible] = useState(false);
  const headingRef = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setHeadingVisible(true); }, { threshold: 0.3 });
    if (headingRef.current) obs.observe(headingRef.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section id="projecten" className="relative py-24 md:py-32 overflow-hidden" style={{ background: '#0a0a0a' }}>
      <div className="absolute inset-0 opacity-20" style={{backgroundImage:`url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.4'/%3E%3C/svg%3E")`,backgroundSize:'200px'}} />
      <div className="relative z-10 px-8 md:px-16 lg:px-24">
        <div ref={headingRef} className="text-center mb-16" style={{ opacity: headingVisible ? 1 : 0, transform: headingVisible ? 'translateY(0)' : 'translateY(40px)', transition: 'all 0.8s cubic-bezier(0.16, 1, 0.3, 1)' }}>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-white italic mb-8">{get(t.projectsHome.heading)}</h2>
          <button onClick={() => { navigate('/projecten'); window.scrollTo({ top: 0 }); }} className="inline-block border-2 text-white px-8 py-3 text-sm font-bold tracking-[0.2em] uppercase transition-all duration-500" style={{ borderColor: '#A855F7' }} onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#A855F7'; }} onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}>
            {get(t.projectsHome.cta)}
          </button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {siteData.projects.items.map((project, index) => (
            <ProjectCard key={project.id} project={project} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
